import { Component, Inject, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Modal, ModalService, ModalServiceToken } from '@lsq-frontend/common-ui';
import { FieldSchema, EditPhoneFieldOption } from '@lsq-frontend/remote-services/ar-app';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';

import { AbstractField } from '../dr-abstract-field/dr-abstract-field';
import { EditPhoneModal } from './edit-phone-modal/edit-phone-modal.component';
import { DrApplicationService } from '../../service/dr-application-service';

@Component({
    selector: 'dr-edit-phone',
    styleUrls: ['./dr-edit-phone.component.scss'],
    templateUrl: './dr-edit-phone.component.html'
})
export class EditPhoneField extends AbstractField implements OnInit {
    @Input() fieldSchema: FieldSchema;

    public fieldOption: EditPhoneFieldOption;
    public _field$: BehaviorSubject<Partial<{ fieldValue: string }>> = new BehaviorSubject({
        fieldValue: ''
    });
    public field: { fieldValue: string };
    public fieldSchemaId: string;

    constructor(
        private _arService: DrApplicationService,
        @Inject(ModalServiceToken) private _modalService: ModalService,
        private _alertService: AlertService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.fieldOption = this.fieldSchema.fieldOption;
        this._field$.next(this.getReferenceValue(this.fieldOption.referenceValue));
        this.getField();
    }

    public getReferenceValue(referenceValue: string): { fieldValue: string } {
        const referenceList = referenceValue.split('.');
        const stage = this._arService.findStage(referenceList.shift());
        const fields = stage.fields;
        this.fieldSchemaId = referenceList.shift();
        return fields[this.fieldSchemaId];
    }

    public openEditPhoneModal() {
        const editPhoneSubject = new BehaviorSubject<boolean>(false);
        const fieldValue = this.field;
        this._modalService.showModal(
            new Modal({
                id: 'edit-phone',
                title: 'Edit Mobile Phone Number',
                component: EditPhoneModal,
                showCloseButton: true,
                data: {
                    fieldValue
                },
                width: '58rem',
                isSubmitting$: editPhoneSubject.asObservable(),
                onOkClick: async () => {
                    editPhoneSubject.next(true);
                    await this.sendVerificationCodeUpdateProspect();
                    editPhoneSubject.next(false);
                }
            })
        );
    }

    public getField(): void {
        this._field$.subscribe((field: { fieldValue: string }) => (this.field = field));
    }

    public async sendVerificationCodeUpdateProspect(): Promise<void> {
        try {
            this.sendVerificationCode();
            this.field = this._modalService.modal.data.fieldValue;
            await this._arService.setPhoneNumber(this.fieldSchemaId, this.field.fieldValue);
            this._field$.next(this.getReferenceValue(this.fieldOption.referenceValue));
        } catch (error) {
            this._alertService.error('Error sending verification code.');
        }
        this._modalService.closeModal();
    }

    public sendVerificationCode(): void {
        this._field$.subscribe(async (field: { fieldValue: string }) => {
            await this._arService.sendPhoneNumberVerificationCodes(field.fieldValue);
        });
    }
}
